import { render, staticRenderFns } from "./ProductsShow.vue?vue&type=template&id=77b17b25&"
import script from "./ProductsShow.vue?vue&type=script&lang=js&"
export * from "./ProductsShow.vue?vue&type=script&lang=js&"
import style0 from "./ProductsShow.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports